import { Link } from "react-router-dom";

const SiteFooter = () => {
  return (
    <footer className="border-t mt-16">
      <div className="container mx-auto py-8 text-sm text-muted-foreground flex flex-col md:flex-row items-center justify-between gap-4">
        <p>&copy; {new Date().getFullYear()} US Height Percentiles</p>
        <nav className="flex items-center gap-4">
          <Link to="/" className="hover:text-foreground">Calculator</Link>
          <Link to="/average-male-height-us" className="hover:text-foreground">Avg Male</Link>
          <Link to="/average-female-height-us" className="hover:text-foreground">Avg Female</Link>
          <Link to="/us-height-distribution" className="hover:text-foreground">Distribution</Link>
          <Link to="/methodology" className="hover:text-foreground">Methodology</Link>
          <Link to="/sources" className="hover:text-foreground">Sources</Link>
          <Link to="/contact" className="hover:text-foreground">Contact</Link>
          <Link to="/privacy" className="hover:text-foreground">Privacy</Link>
          <Link to="/terms" className="hover:text-foreground">Terms</Link>
        </nav>
      </div>
    </footer>
  );
};

export default SiteFooter;
